import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import { Auth } from './auth';
import { AuthService } from '../services/auth.service';

@Injectable()
export class FileUploadService {
  /**
   * @param Observable<number>
   */
  private progress$: Observable<number>;

  /**
   * @type {number}
   */
  private progress = 0;

  private progressObserver: any;

  constructor() {
    this.progress$ = new Observable(observer => {
      this.progressObserver = observer;
    });
  }

  /**
   * @returns {Observable<number>}
   */
  public getObserver(): Observable<number> {
    return this.progress$;
  }

  /**
   * Upload files through XMLHttpRequest
   *
   * @param url
   * @param files
   * @returns {Promise<T>}
   */
  public upload(
    url: string,
    files: File[],
    formValues: Map<string, string> = null
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i], files[i].name);
      }

      if (formValues != null) {
        formValues.forEach((value, key, map) => {
          formData.append(key, value);
        });
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = event => {
        // this.progress = Math.round(event.loaded / event.total * 100);

        // this.progressObserver.next(this.progress);
      };

      xhr.open('POST', url, true);
      xhr.setRequestHeader(
        'Authorization',
        'Bearer ' + AuthService.currentUser().token
      );
      xhr.setRequestHeader('enctype', 'multipart/form-data');
      xhr.setRequestHeader('Cache-Control', 'no-cache');
      xhr.setRequestHeader('Cache-Control', 'no-store');
      xhr.setRequestHeader('Pragma', 'no-cache');
      xhr.send(formData);
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/core/file-upload.service.ts